import { Observable } from "rxjs";
import { EFavoriteGetQueryType, EFavoriteType, FavoriteDto, ProductIdentifierDto } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IFavoriteService {
  abstract favoriteGet(favoriteGetQueryType: EFavoriteGetQueryType): Observable<FavoriteDto[]>;

  abstract favoriteSet(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<boolean>;

  abstract favoriteDelete(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<boolean>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IFavoriteServiceToken = new InjectionToken<IFavoriteService>('IFavoriteServiceToken');
